module.exports = __webpack_public_path__ + "static/media/apollo_clinic_barrackpore.0c64fb60.png";